import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BookReceiptIndetailallComponent } from '../book-receipt-indetailall/book-receipt-indetailall.component';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-book-receipt-all-briefly',
  // standalone: true,
  // imports: [],
  templateUrl: './book-receipt-all-briefly.component.html',
  styleUrl: './book-receipt-all-briefly.component.scss'
})
export class BookReceiptAllBrieflyComponent {
   PaymentBookOffInDFormBenas: any[] = [];
    PaymentbookOffInDTotal2: number = 0;
    startDate: string = '';
     currentDate= new Date();
    endDate: string = '';
    // officeRepName: string = ''; // ✅ Added filter field
    reportType = 'All Briefly';
    loading = false;
    officerepwise: any;
    repName: any;
  show: boolean;
  
    constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private dialogRef: MatDialogRef<BookReceiptAllBrieflyComponent>,
      private service: DigisubservicesService
    ) {}
  
    ngOnInit(): void {
      debugger;
      console.log('Dialog data received:', this.data);
  
      this.startDate = this.data?.start_date || this.data?.startDate || '';
      this.endDate = this.data?.end_date || this.data?.endDate || '';
       this.officerepwise = this.data?.office_rep_name || this.data?.officerepwise || ''; // ✅ fetch from dialog data if passed
       this.repName = this.data?.rep_name || this.data?.repName || '';
    
  
      if (!this.startDate || !this.endDate) {
        console.warn('⚠️ Missing start_date or end_date in dialog data');
        return;
      }
  
      this.getReportData();
    }
  
    // ✅ Fetch Report Data with Filter
    getReportData(): void {
      debugger;
      this.loading = true;
  
      const payload: any = {
        start_date: this.startDate,
        end_date: this.endDate,
        // office_rep_name:this.officerepwise,
        office_rep_name: this.officerepwise,
        rep_name: this.repName
      };
  
    
  
      console.log('📤 Payload being sent to API:', payload);
  
      this.service.getBookPaymentRegiOffInDetails1(payload).subscribe({
        next: (res: any) => {
          console.log('✅ API response received:', res);
          this.PaymentBookOffInDFormBenas = res || [];
          this.calculateGrandTotal();
          this.loading = false;
        },
        error: (err) => {
          console.error('❌ Error fetching report data:', err);
          this.loading = false;
        }
      });
    }
  
    // ✅ Dynamic Grand Total Calculation
    calculateGrandTotal(): void {
      let total = 0;
  
      for (let office of this.PaymentBookOffInDFormBenas) {
        if (office.rep_data && Array.isArray(office.rep_data)) {
          for (let rep of office.rep_data) {
            if (rep.book_sellers && Array.isArray(rep.book_sellers)) {
              for (let seller of rep.book_sellers) {
                total += parseFloat(seller.rcv_amt) || 0;
              }
            }
          }
        }
      }
  
      this.PaymentbookOffInDTotal2 = total;
      console.log('✅ Calculated Grand Total:', this.PaymentbookOffInDTotal2);
    }
  
    // ✅ Excel Export
    // exportExcel(fileName: string): void {
    //   const element = document.getElementById('print-section');
    //   if (!element) return;
  
    //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(wb, ws, 'Report');
    //   XLSX.writeFile(wb, `${fileName}.xlsx`);
    // }
  
    // ✅ Print Function
//   printPage4() {
//   const printContent = document.getElementById('print-section');
//   const WindowPrt = window.open('', '', 'width=1000,height=1200');

//   WindowPrt.document.write(`
//     <html>
//       <head>
//         <title>Book Payment Receipt Report</title>
//         <style>
//           /* ===== PAGE SETUP ===== */
//           @page {
//             size: A4 portrait;
//             margin: 10mm;
//           }

//           html, body {
//             margin: 0;
//             padding: 0;
//             font-family: Arial, sans-serif;
//             font-size: 13px;
//             color: #000;
//             -webkit-print-color-adjust: exact !important;
//             print-color-adjust: exact !important;
//           }

//           /* ===== TABLE STRUCTURE ===== */
//           table {
//             width: 100%;
//             border-collapse: collapse;
//             border-spacing: 0;
//             table-layout: auto;
//             word-wrap: break-word;
//           }

//           th, td {
//             border: 1px solid black;
//             padding: 6px 8px;
//             vertical-align: middle;
//           }

//           th {
//             background-color: #f1f1f1 !important;
//             text-align: center;
//             font-weight: bold;
//           }

//           tr:nth-child(even) td {
//             background-color: #fafafa;
//           }

//           /* ===== HEADER SECTION ===== */
//           .header-table {
//             width: 100%;
//             border: 1px solid black;
//             border-collapse: collapse;
//             background-color: #f8f9fa !important;
//           }

//           .header-table td {
//             padding: 8px 6px;
//             font-weight: bold;
//             font-size: 15px;
//             border: 1px solid black;
//           }

//           /* ===== COLOR ROWS ===== */
//           tr.office-row td {
//             background-color: #e6f2ff !important;
//             font-weight: bold;
//             text-align: center;
//           }

//           tr.rep-row td {
//             background-color: #f9f9f9 !important;
//             font-weight: bold;
//           }

//           tr.rep-total td {
//             background-color: #fff7e6 !important;
//             font-weight: bold;
//           }

//           tr.office-total td {
//             background-color: #ffe6e6 !important;
//             font-weight: bold;
//           }

//           /* ===== GRAND TOTAL ROW ===== */
//           .grand-total-row td {
//             background-color: #d9ead3 !important;
//             font-weight: bold;
//             text-align: right;
//           }

//           /* ===== PRINT OPTIMIZATION ===== */
//           tr, td, th {
//             page-break-inside: avoid !important;
//           }

//           table {
//             page-break-after: auto;
//           }

//           thead {
//             display: table-header-group;
//           }

//           tfoot {
//             display: table-row-group !important;
//           }

//           /* ===== PRINT SCALING ===== */
//           @media print {
//             body {
//               -webkit-transform: scale(0.98);
//               transform: scale(0.98);
//               transform-origin: top left;
//             }

//             .noPrint {
//               display: none !important;
//             }
//           }
//         </style>
//       </head>
//       <body>
//         ${printContent?.innerHTML}
//       </body>
//     </html>
//   `);

//   WindowPrt.document.close();
//   WindowPrt.focus();

//   setTimeout(() => {
//     WindowPrt.print();
//     WindowPrt.close();
//   }, 600);
// }

// printPage4() {
//   this.show = true;

//   const printSection = document.getElementById("print-section");
//   if (!printSection) {
//     console.error("Print section not found!");
//     return;
//   }

//   const printContent = printSection.innerHTML;
//   const printWindow = window.open("", "", "width=1000,height=1200");

//   printWindow.document.write(`
//     <html>
//       <head>
//         <title>Book Payment Receipt Ledger</title>

//         <style>

//           /* ===== PAGE SETUP ===== */
//           @page {
//             size: A4 portrait;
//             margin: 12mm;
//           }

//           body {
//             font-family: Arial, sans-serif;
//             padding: 0;
//             margin: 0;
//             font-size: 13px;
//             -webkit-print-color-adjust: exact !important;
//             print-color-adjust: exact !important;
//           }

//           /* ===== GLOBAL TABLE STYLES ===== */
//           table {
//             width: 100%;
//             border-collapse: collapse;
//             table-layout: auto;
//           }

//           th, td {
//             border: 1px solid black;
//             padding: 4px 6px;
//             vertical-align: middle;
//           }

//           th {
//             background-color: #f1f1f1 !important;
//             font-weight: bold;
//             text-align: center;
//           }

//           /* ===== FIX REPEATING TABLE HEADER ===== */
//           thead {
//             display: table-header-group !important;
//           }

//           tfoot {
//             display: table-footer-group !important;
//           }

//           /* ===== ROW BREAK PROTECTION ===== */
//           tr {
//             page-break-inside: avoid !important;
//           }

//           /* ===== COLOR ROWS ===== */
//           tr.office-row td {
//             background-color: #e6f2ff !important;
//             font-weight: bold;
//           }

//           tr.rep-row td {
//             background-color: #f9f9f9 !important;
//             font-weight: bold;
//           }

//           tr.rep-total td {
//             background-color: #fff7e6 !important;
//             font-weight: bold;
//           }

//           tr.office-total td {
//             background-color: #ffe6e6 !important;
//             font-weight: bold;
//           }

//           .grand-total-row td {
//             background-color: #d9ead3 !important;
//             font-weight: bold;
//             text-align: right;
//           }

//           /* ===== PRINT SCALING ===== */
//           @media print {
//             .noPrint { display: none !important; }
//             body {
//               transform: scale(0.96);
//               transform-origin: top left;
//             }
//           }
//         </style>
//       </head>

//       <body>

//         <!-- KEEP ONLY ONE HEADER (removed duplicate print header) -->
//         ${printContent}

//       </body>
//     </html>
//   `);

//   printWindow.document.close();

//   setTimeout(() => {
//     printWindow.focus();
//     printWindow.print();
//     printWindow.close();
//   }, 300);
// }

printPageA4(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=900,height=1200');

  WindowPrt!.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Book Credit Note Report</title>
        <style>

          /* ===== ENSURE COLORS & BORDERS PRINT ===== */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* ===== A4 PORTRAIT PAGE ===== */
          @page {
            size: A4 portrait;
            margin: 8mm 6mm 8mm 15mm; /* top right bottom left */
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 11px;
            color: #000;
            -webkit-font-smoothing: none;
          }

          /* ===== TABLE ===== */
          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #000;   /* outer border */
          }

          th, td {
            border: 1px solid #000;
            padding: 5px 6px;
            vertical-align: middle;
            white-space: nowrap;
            text-align: left;
          }

          thead {
            display: table-header-group;
             borde-right: 1px solid #000;
          }

          tr {
            page-break-inside: avoid;
          }

          /* ===== FOOTER ===== */
          tfoot {
            display: table-row-group;
            font-weight: bold;
          }

          /* ===== PRINT ONLY ===== */
          @media print {
            .noPrint { display: none !important; }
          }

        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt!.document.close();
  WindowPrt!.focus();

  setTimeout(() => {
    WindowPrt!.print();
    WindowPrt!.close();
  }, 500);
}

exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);

    let element = document.getElementById('print-section');
    console.log('Element found:', element);

    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }

    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }







  
  
  
  
  
  
  }
  


